"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Select = function Select(_ref) {
  var questionId = _ref.questionId,
      disabled = _ref.disabled,
      choices = _ref.choices,
      setValue = _ref.setValue,
      error = _ref.error,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    name: questionId + "-Select-FormGroup",
    error: error ? _constants.SELECT_TYPE_ERROR : ''
  }, /*#__PURE__*/_react.default.createElement(_form.SelectField, {
    name: questionId + "-Select",
    options: choices.map(function (c) {
      return {
        label: c.value,
        value: c.id
      };
    }),
    disabled: disabled,
    onChange: function onChange(e) {
      return setValue([e.target.value]);
    },
    defaultValue: value
  }))));
};

Select.propTypes = {
  /** The unique identifier of the question */
  questionId: _propTypes.default.string.isRequired,

  /** The list of choices */
  choices: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the choice */
    id: _propTypes.default.string,

    /** The value of the choice */
    value: _propTypes.default.string
  })),

  /** Indicates whether the question component should be disabled */
  disabled: _propTypes.default.bool,

  /** Function to set the response value for this component */
  setValue: _propTypes.default.func,

  /** Indicates whether there is an error with the given response */
  error: _propTypes.default.bool
};
Select.defaultProps = {
  choices: [],
  disabled: false,
  setValue: function setValue() {},
  error: false
};
var _default = Select;
exports.default = _default;